import SupplierDropdown from 'components/SupplierDropdown';
import React, { useState } from 'react';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddSupplierOnUserModal = props => {
  const [selectedSupplierId, setSelectedSupplierId] = useState<string>('');
  const [supplier, setSupplier] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [supplierSelected, setSupplierSelected] = useState<boolean>(false);
  const {
    userId,
    addSupplierAPI,
    onSuccess,
    toggleModal,
  } = props;

  const addSupplier = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addSupplierAPI(userId, selectedSupplierId);
      await onSuccess();
      showSuccess('Supplier added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  const setSupplierDetails = (supplier: Record<string, any>) => {
    const supplierData = {
      name: supplier.name,
      address: supplier.address,
      phone: supplier.phone,
      email: supplier.email?.toLowerCase(),
    };
    setSupplier(supplierData);
  };

  const handleSelect = (id: string) => {
    setSelectedSupplierId(id);
    setSupplierSelected(true);
  };

  const SupplierDetails = () => (
    <div className={styles['supplier-details']}>
      <div className={styles['supplier-name-section']}>
        <div className={styles['label']}>Supplier Name</div>
        <div className={styles['supplier-name']}>{supplier.name}</div>
        <div className={styles['supplier-address']}>{supplier.address || ''}</div>
      </div>
      <div className={styles['supplier-phone-section']}>
        <div className={styles['label']}>Phone Number</div>
        <div className={styles['supplier-phone']}>{supplier.phone || 'N/A'}</div>
      </div>
      <div className={styles['supplier-email-section']}>
        <div className={styles['label']}>Email</div>
        <div className={styles['supplier-email']}>{supplier.email || 'N/A'}</div>
      </div>
    </div>
  );

  return (
    <form onSubmit={e => e.preventDefault()} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Supplier</div>
            <div className={styles['modal-title']}>Add a New Supplier</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={'mb-3'}>
            <div className={styles['label']}>Supplier</div>
            <SupplierDropdown
              disabled={loading}
              setSupplierDetails={setSupplierDetails}
              setSelectedSupplier={handleSelect}
            />
          </div>
          {supplierSelected && <SupplierDetails />}
        </div>
        <div className={styles['modal-footer']}>
          <button
            type={'button'}
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'button'}
            className={styles['submit-button']}
            disabled={loading}
            onClick={addSupplier}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddSupplierOnUserModal;
